<div
  class="counseling-memo-dynamic-field-input__panel"
  *ngIf="readonly"
  [ngClass]="{
    'filled': checkIsValueFilled(valueCtrl.value)
  }"
  [ngSwitch]="getDisplayVariant()"
>
  <!-- <ng-container *ngSwitchCase="'multilist'">
    <div class="counseling-memo-dynamic-field-input__chips-row">
      <div class="counseling-memo-dynamic-field-input__chips">
        <span
          class="counseling-memo-dynamic-field-input__chip"
          *ngFor="let item of (checkIsArray(valueCtrl.value) ? valueCtrl.value : []); let i = index"
        >
          <span class="counseling-memo-dynamic-field-input__chip-text">{{ item }}</span>
        </span>
      </div>
    </div>

    <div class="counseling-memo-dynamic-field-input__selected-count">
      選択中 {{ (valueCtrl.value?.length || 0) }}件
    </div>
  </ng-container> -->
  <ng-container *ngSwitchCase="DynamicFieldDisplayVariant.industry">
    <div class="counseling-memo-dynamic-field-input__readonly-display">
      {{ displayableLabelValue }}
    </div>
  </ng-container>
  <ng-container *ngSwitchCase="DynamicFieldDisplayVariant.jobType">
    <div class="counseling-memo-dynamic-field-input__readonly-display">
      {{ displayableLabelValue }}
    </div>
  </ng-container>

  <ng-container *ngSwitchCase="DynamicFieldDisplayVariant.certificate">
    <div class="counseling-memo-dynamic-field-input__readonly-display">
      {{ displayableLabelValue }}
    </div>
  </ng-container>
  <ng-container *ngSwitchCase="DynamicFieldDisplayVariant.multilist">
    <div
      class="counseling-memo-dynamic-field-input__readonly-display"
    >
      {{(checkIsArray(valueCtrl.value) ? valueCtrl.value : []).join(' / ')}}
    </div>
    <div class="counseling-memo-dynamic-field-input__selected-count">
      選択中 {{ (valueCtrl.value?.length || 0) }}件
    </div>
  </ng-container>
  <ng-container *ngSwitchDefault>
    <div
      class="counseling-memo-dynamic-field-input__readonly-display"
    >
      {{valueCtrl.value}}
    </div>
  </ng-container>
</div>

<!-- 入力可能時 -->
<div
  class="counseling-memo-dynamic-field-input__panel"
  *ngIf="!readonly"
  [ngClass]="{
    'filled': checkIsValueFilled(valueCtrl.value)
  }"
  [ngSwitch]="getDisplayVariant()"
>
  <!-- industry -->
  <ng-container *ngSwitchCase="DynamicFieldDisplayVariant.industry">
    <ag-select
     
      class="counseling-memo-dynamic-field-input__dropdown"
      [disabled]="disabled"
      [options]="getIndustryOptions()"
      valueField="value"
      labelField="label"
      [ngModel]="getIndustryCode()"
      (ngModelChange)="onIndustryCodeChange($event)"
      [ngModelOptions]="{ standalone: true }"
    >
    </ag-select>
  </ng-container>

  <!-- job-type -->
  <ng-container *ngSwitchCase="DynamicFieldDisplayVariant.jobType">
    <div class="counseling-memo-dynamic-field-input__column">
      <ag-select
        class="counseling-memo-dynamic-field-input__dropdown"
        [options]="jobTypeCode1Options"
        valueField="value"
        labelField="label"
        [value]="getJobTypeCode1()"
        (valueChange)="onJobTypeCode1Change($event)"
      >
      </ag-select>

      <ag-select
        class="counseling-memo-dynamic-field-input__dropdown"
        [options]="jobTypeCode2Options"
        valueField="value"
        labelField="label"
        [value]="getJobTypeCode2()"
        (valueChange)="onJobTypeCode2Change($event)"
      >
      </ag-select>
    </div>
  </ng-container>

  <!-- certificate -->
  <ng-container *ngSwitchCase="DynamicFieldDisplayVariant.certificate">
    <div class="counseling-memo-dynamic-field-input__column">
      <!-- Dropdown1: 資格名（label=name, value=code） -->
      <div class="counseling-memo-dynamic-field-input__row">
        <span class="counseling-memo-dynamic-field-input__row--head">資格</span>
        <span class="counseling-memo-dynamic-field-input__row--body">
          <ag-autocomplete
            class="counseling-memo-dynamic-field-input__autocomplete"
            [disabled]="disabled"
            [options]="certificateNameOptions"
            valueField="value"
            labelField="label"
            [ngModel]="getCertificateCode()"
            (ngModelChange)="onCertificateCodeChange($event)"
            [ngModelOptions]="{ standalone: true }"
          >
          </ag-autocomplete>
        </span>
      </div>

      <!-- Dropdown2: 等級（label=gradeName, value=gradeCode） -->
      <div class="counseling-memo-dynamic-field-input__row">
        <span class="counseling-memo-dynamic-field-input__row--head">資格等級</span>
        <span class="counseling-memo-dynamic-field-input__row--body">
          <ag-select
            class="counseling-memo-dynamic-field-input__dropdown"
            [disabled]="disabled || !getCertificateCode()"
            [options]="certificateGradeNameOptions"
            valueField="value"
            labelField="label"
            [ngModel]="getCertificateGradeCode()"
            (ngModelChange)="onCertificateGradeCodeChange($event)"
            [ngModelOptions]="{ standalone: true }"
          >
          </ag-select>
        </span>
      </div>
      <div class="counseling-memo-dynamic-field-input__row">
        <div class="counseling-memo-dynamic-field-input__row--head">資格取得日</div>
        <div class="counseling-memo-dynamic-field-input__row--body">
          <!-- issueYear: number -->
          <input
            class="counseling-memo-dynamic-field-input__certificate-year-number"
            type="number"
            [disabled]="disabled || !getCertificateCode()"
            [ngModel]="getCertificateIssueYear()"
            (ngModelChange)="onCertificateIssueYearChange($event)"
            [ngModelOptions]="{ standalone: true }"
          />
          年
          <!-- issueMonth: Dropdown3(1-12) -->
          <span class="counseling-memo-dynamic-field-input__certificate-month-dropdown">
            <ag-select
              [disabled]="disabled || !getCertificateCode()"
              [options]="getMonthOptions()"
              valueField="value"
              labelField="label"
              [ngModel]="getCertificateIssueMonth()"
              (ngModelChange)="onCertificateIssueMonthChange($event)"
              [ngModelOptions]="{ standalone: true }"
            >
            </ag-select>
          </span>
        </div>
      </div>
    </div>
  </ng-container>

  <!-- multi-* / multi-list -->
  <ng-container *ngSwitchCase="DynamicFieldDisplayVariant.multilist">
    <div class="counseling-memo-dynamic-field-input__chips-row">
      <div class="counseling-memo-dynamic-field-input__chips">
        <span
          class="counseling-memo-dynamic-field-input__chip"
          *ngFor="let item of (checkIsArray(valueCtrl.value) ? valueCtrl.value : []); let i = index"
        >
          <span class="counseling-memo-dynamic-field-input__chip-text">{{ item }}</span>
          <button
            type="button"
            class="counseling-memo-dynamic-field-input__chip-remove"
            [disabled]="readonly"
            (click)="removeChip(i)"
            aria-label="remove"
          >
            ×
          </button>
        </span>
      </div>

      <button
        *ngIf="shouldShowAddButton() && !isMultiListOptionsOpen"
        type="button"
        class="counseling-memo-dynamic-field-input__add-btn"
        [disabled]="readonly"
        (click)="toggleSelectOptionArea()"
      >
        追加
      </button>
      <button
        *ngIf="isMultiListOptionsOpen"
        type="button"
        class="counseling-memo-dynamic-field-input__select-close-btn"
        [disabled]="readonly"
        (click)="toggleSelectOptionArea()"
      >
        閉じる
      </button>
    </div>
    <!-- ★追加: 選択候補一覧（validationStyle.options） -->
    <div class="counseling-memo-dynamic-field-input__options" *ngIf="isMultiListOptionsOpen">
      <ng-container 
        *ngFor="let option of getMultiListOptions()"
      >
        <span
          type="button"
          *ngIf="!isMultiListOptionSelected(option)"
          class="counseling-memo-dynamic-field-input__chip counseling-memo-dynamic-field-input__chip--option"
          (click)="addMultiListOption(option)"
        >
          <label class="counseling-memo-dynamic-field-input__chip-text">{{ option }}</label>
        </span>

      </ng-container>
    </div>

    <div class="counseling-memo-dynamic-field-input__selected-count">
      選択中 {{ (valueCtrl.value?.length || 0) }}件
    </div>
  </ng-container>

  <!-- list -->
  <ng-container *ngSwitchCase="DynamicFieldDisplayVariant.list">
    <div
      class="counseling-memo-dynamic-field-input__list"
      role="radiogroup"
      [attr.aria-label]="fieldDefinition?.label || fieldDefinition?.fieldName"
    >
      <label
        class="counseling-memo-dynamic-field-input__list-item"
        *ngFor="let item of getListItems(); let i = index"
        [class.counseling-memo-dynamic-field-input__list-item--selected]="isListItemSelected(item)"
        [attr.for]="makeListItemId(i)"
        (mousedown)="onSelectListItem(item, $event)"
      >
        <input
          class="counseling-memo-dynamic-field-input__list-item-input"
          type="radio"
          [id]="makeListItemId(i)"
          [name]="makeListGroupName()"
          [value]="item"
          [formControl]="valueCtrl"
          [checked]="isListItemSelected(item)"
          (click)="$event.preventDefault(); $event.stopPropagation()"
          (focus)="onFocus()"
          (blur)="onBlur()"
        />
        <span class="counseling-memo-dynamic-field-input__list-item-label">{{ item }}</span>
      </label>
    </div>
  </ng-container>


  <!-- textarea -->
  <ng-container *ngSwitchCase="DynamicFieldDisplayVariant.textarea">
    <textarea
      class="counseling-memo-dynamic-field-input__textarea"
      [ngClass]="{
        'filled': checkIsValueFilled(valueCtrl.value)
      }"
      [placeholder]="placeholder || ''"
      [formControl]="valueCtrl"
      (focus)="onFocus()"
      (blur)="onBlur()"
    ></textarea>
  </ng-container>

  <!-- date -->
  <ng-container *ngSwitchCase="DynamicFieldDisplayVariant.date">
    <input
      class="counseling-memo-dynamic-field-input__input counseling-memo-dynamic-field-input__input--date"
      [ngClass]="{
        'filled': checkIsValueFilled(valueCtrl.value)
      }"
      type="date"
      [formControl]="valueCtrl"
      [placeholder]="placeholder || ''"
      (focus)="onFocus()"
      (blur)="onBlur()"
    />
  </ng-container>

  <!-- email -->
  <ng-container *ngSwitchCase="DynamicFieldDisplayVariant.email">
    <input
      class="counseling-memo-dynamic-field-input__input counseling-memo-dynamic-field-input__input--email"
      [ngClass]="{
        'filled': checkIsValueFilled(valueCtrl.value)
      }"
      type="email"
      [formControl]="valueCtrl"
      [placeholder]="placeholder || ''"
      (focus)="onFocus()"
      (blur)="onBlur()"
    />
  </ng-container>

  <!-- tel -->
  <ng-container *ngSwitchCase="DynamicFieldDisplayVariant.tel">
    <input
      class="counseling-memo-dynamic-field-input__input counseling-memo-dynamic-field-input__input--tel"
      [ngClass]="{
        'filled': checkIsValueFilled(valueCtrl.value)
      }"
      type="tel"
      [formControl]="valueCtrl"
      [placeholder]="placeholder || ''"
      (focus)="onFocus()"
      (blur)="onBlur()"
    />
  </ng-container>

  <!-- number -->
  <ng-container *ngSwitchCase="DynamicFieldDisplayVariant.number">
    <input
      class="counseling-memo-dynamic-field-input__input counseling-memo-dynamic-field-input__input--number"
      [ngClass]="{
        'filled': checkIsValueFilled(valueCtrl.value)
      }"
      type="number"
      [formControl]="valueCtrl"
      [placeholder]="placeholder || ''"
      (focus)="onFocus()"
      (blur)="onBlur()"
    />
  </ng-container>

  <!-- default: text -->
  <ng-container *ngSwitchDefault>
    <input
      class="counseling-memo-dynamic-field-input__input counseling-memo-dynamic-field-input__input--text"
      [ngClass]="{
        'filled': checkIsValueFilled(valueCtrl.value)
      }"
      type="text"
      [formControl]="valueCtrl"
      [placeholder]="placeholder || ''"
      (focus)="onFocus()"
      (blur)="onBlur()"
    />
  </ng-container>
</div>
